{
  "TeamsAuth_UserIntro": "Hi **{}**,",
  "TeamsAuth_UserIntro_2": "Akixi for MS Teams is requesting access to your Microsoft Entra Tenant",
  "TeamsAuth_AdminConsent": "Grant Admin Consent",
  "TeamsAuth_Authorise": "Authorise",
  "TeamsAuth_ConsentedMessage": "Admin Consent granted, please click Authorise to continue",
  "TeamsAuth_AuthorisedMessage": "Authorisation granted",
  "TeamsAuth_Decline": "Decline",
  "TeamsAuth_Error_Unknown": "An unrecognised error has occurred. Please try again. If the problem persists, please contact your system administrator.",
  "TeamsAuth_Authoriser_Select_Title": "Which users would you like to Sync from your Microsoft Entra Tenant?",
  "TeamsAuth_Authoriser_Select_Options_Tenant": "All applicable Users from Tenant",
  "TeamsAuth_Authoriser_Select_Options_SecurityGroups": "Selected Security Group/s Only",
  "TeamsAuth_SecurityGroups_Loader_Title_1": "Getting Security Groups",
  "TeamsAuth_SecurityGroups_Loader_Title_2": "This shouldn't take long, please bear with us...",
  "TeamsAuth_SecurityGroups_Title": "Please select your security groups",
  "TeamsAuth_SecurityGroups_SecurityGroup_NothingToSee": "No Security Groups were found...",
  "TeamsAuth_SecurityGroups_SecurityGroup": "[ID: {}]",
  "TeamsAuth_SecurityGroups_Note": "Note: Security Groups can be updated later",
  "TeamsAuth_SecurityGroups_SyncAndClose": "Sync and Close",
  "TeamsAuth_SecurityGroups_NoSecurityGroups": "Sync whole Tenant",
  "NAME": "TeamsAuth"
}